// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { OrderApprovalsDataViewContext } from "@insite/client-framework/Store/Data/OrderApprovals/OrderApprovalsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageTitleCount from "@conklin/App/Components/Common/PageTitleCount";
import React, { FC, useContext } from "react";

const OrderApprovalListTitleCount: FC<WidgetProps> = () => {
    const orderApprovalsDataView = useContext(OrderApprovalsDataViewContext);

    const orderApprovalsCount = orderApprovalsDataView.value
        ? orderApprovalsDataView.pagination
            ? orderApprovalsDataView.pagination.totalItemCount
            : 0
        : 0;

    return <PageTitleCount countNumber={orderApprovalsCount} noun="Order" />;
};

const widgetModule: WidgetModule = {
    component: OrderApprovalListTitleCount,
    definition: {
        group: "Order Approval List",
        displayName: "Title Count",
        allowedContexts: ["OrderApprovalListPage"],
    },
};

export default widgetModule;
